import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Subject } from 'rxjs';
import { NextPreAction, NextPreValue } from 'src/app/models/forecast/NextPrevious';
import { NextPreviousList, NextPreviousOption, SelectionDDL, SettingsService } from 'src/app/pages/settings/settings.service';
import { TaskData } from 'src/app/pages/stock/stock.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { AppDevNotifyComponent } from '../dev-notify-bar/dev-notify-bar.component';

@Component({
  selector: 'app-next-previous-popup',
  templateUrl: './next-previous-popup.component.html',
  styleUrls: ['./next-previous-popup.component.scss'],
  standalone: false
})
export class NextPreviousPopupComponent implements OnInit {

  @Input() pageName: string = "";
  @Output() nextPreChange: EventEmitter<NextPreValue> = new EventEmitter<NextPreValue>();
  @Output() resetPreDieldChange: EventEmitter<string> = new EventEmitter<string>();

  nextpreAction: NextPreAction;
  nextPreValue: NextPreValue;
  isBlankSelection = true;

  isDefault: boolean = false;
  popuploadNxtPreVisible: boolean = false;
  itemField: SelectionDDL[] = [];
  itemFieldSel: SelectionDDL[] = [];
  itemFieldList: NextPreviousList[] = [];
  isDefualt: boolean = false;

  taskNewFilter: TaskData;
  taskFilter: TaskData[] = [];
  preNextFieldName = null;
  @Input() changing: Subject<boolean>;
  constructor(private settingsService: SettingsService, private shareDataService: ShareDataService) {

  }

  ngOnInit() {
    if (this.pageName != null && this.pageName != "") {
      this.LoadDataList('pageload');
    }
    this.changing.subscribe(v => {
      if (this.nextPreValue != undefined && this.nextPreValue.currentValue != undefined
        && this.nextPreValue != null && this.nextPreValue.currentValue != null) {
        this.nextPreValue.currentValue = null;
      }
      if (this.isBlankSelection != undefined) {
        this.isBlankSelection = true;
      }
      if (this.IsNxtExists != undefined) {
        this.IsNxtExists = false;
      }
    });
  }

  IsPrevExists = true;
  IsNxtExists = false;


  IsPRevEnable() {
    if (this.isBlankSelection || this.IsPrevExists) {
      return true;
    }
    return false;
  }
  onNextPreviousButtonClicked(action: string) {
    if (action == 'Next-Previous') {
      this.popuploadNxtPreVisible = true;
    }
    else if (this.fieldName != null && this.fieldName != "") {
      let IsNUllValue = false;
      if (this.preNextFieldName == null) {
        this.preNextFieldName = this.fieldName;
      }
      this.nextpreAction = new NextPreAction();
      this.nextpreAction.Action = this.pageName;
      this.nextpreAction.ColumnName = this.fieldName;
      this.nextpreAction.CurrentValue = null;
      if (this.nextPreValue != null && this.nextPreValue.currentValue != null) {
        if (action == 'Previous') {
          this.nextpreAction.CurrentValue = this.nextPreValue.prevValue;
          if ((this.nextPreValue.prevValue == null || this.nextPreValue.prevValue == "") && !this.isBlankSelection) {
            IsNUllValue = true;
            AppDevNotifyComponent.SuccesMessage("You have reached end of list.");
          }
        }
        if (action == 'Next') {
          this.nextpreAction.CurrentValue = this.nextPreValue.nextValue;
          if ((this.nextPreValue.nextValue == null || this.nextPreValue.nextValue == "") && !this.isBlankSelection) {
            IsNUllValue = true;
            AppDevNotifyComponent.SuccesMessage("You have reached end of list.");
          }
        }
        this.nextPreValue.columnName = this.fieldName;
        this.nextPreValue.action = action;
      }

      if (IsNUllValue) {
      }
      else if (action == 'Previous' || action == 'Next') {

        this.taskFilter = [];
        if (this.shareDataService.filterOptions && this.shareDataService.filterOptions.filters) {
          this.shareDataService.filterOptions.filters.forEach(itemFilter => {
            this.taskNewFilter = new TaskData();
            this.taskNewFilter.SettingValue = itemFilter.fieldValue;
            this.taskNewFilter.SettingId = itemFilter.settingId;
            this.taskNewFilter.FieldName = '';
            this.taskFilter.push(this.taskNewFilter);
          });
        }

        if (this.shareDataService.filterOptionOverview && this.shareDataService.filterOptionOverview.filters) {
          this.shareDataService.filterOptionOverview.filters.forEach(itemFilter => {
            this.taskNewFilter = new TaskData();
            this.taskNewFilter.SettingValue = itemFilter.value;
            this.taskNewFilter.FieldName = itemFilter.fieldName;
            this.taskNewFilter.SettingId = null;
            this.taskFilter.push(this.taskNewFilter);
          });
        }

        if (this.shareDataService.capacityOverviewSelectedColumn) {
          this.taskNewFilter = new TaskData();
          this.taskNewFilter.SettingValue = this.shareDataService.capacityOverviewSelectedColumn;
          this.taskNewFilter.FieldName = "CapacityColumn";
          this.taskNewFilter.SettingId = null;
          this.taskFilter.push(this.taskNewFilter);
        }


        this.nextpreAction.taskFilterData = [];
        this.nextpreAction.taskFilterData = this.taskFilter;

        this.settingsService.SelectNextPreData(this.nextpreAction).subscribe((result) => {
          this.nextPreValue = result;
          this.nextPreValue.columnName = this.fieldName;
          this.nextPreValue.action = action;

          this.isBlankSelection = false;

          if (this.nextPreValue) {
            if ((this.nextPreValue.prevValue == null || this.nextPreValue.prevValue == "") && !this.isBlankSelection) {
              this.IsPrevExists = true;
            } else {
              this.IsPrevExists = false;
            }
            if ((this.nextPreValue.nextValue == null || this.nextPreValue.nextValue == "") && !this.isBlankSelection) {
              this.IsNxtExists = true;
            } else {
              this.IsNxtExists = false;
            }
          }
          this.nextPreChange.emit(this.nextPreValue);
        }, err => {

          AppDevNotifyComponent.ErrorMessage("Something Went Wrong.");
        });
      }

    } else {
      AppDevNotifyComponent.ErrorMessage("Please select field for next-pervious.");
    }

  }

  fieldName: string = "";
  AddNewField($event) {
    if (this.nextPreValue != undefined && this.nextPreValue.currentValue != undefined
      && this.nextPreValue != null && this.nextPreValue.currentValue != null) {
      this.nextPreValue.currentValue = null;
    }

    if (this.preNextFieldName != this.fieldName) {
      if (this.preNextFieldName != null) {
        this.resetPreDieldChange.emit(this.preNextFieldName);
      }
      this.preNextFieldName = this.fieldName;
    }

    let objData = new NextPreviousOption();
    objData.FieldName = this.fieldName;
    objData.IsDefault = this.isDefualt;
    objData.PageName = this.pageName;
    this.settingsService.InsetUpdateField(objData).subscribe((result) => {
      if (result != null && result.length > 0) {
        if (result[0].flag > 0) {
          AppDevNotifyComponent.SuccesMessage(result[0].msg);
        }
        else {
          AppDevNotifyComponent.ErrorMessage(result[0].msg);
        }
      }
      this.LoadDataList('reload');
      this.onNextPreviousButtonClicked("Next");
      this.popuploadNxtPreVisible = false;

    }, err => {

      AppDevNotifyComponent.ErrorMessage("Something Went Wrong.");
    });
  }

  SelectionFieldName: string = "";
  LoadDataList(action: string) {

    this.isDefualt = false;

    this.settingsService.GetNextPreList('ListDataNextPre' + this.pageName).subscribe((result) => {
      this.itemFieldList = result;
      let itemF = this.itemFieldList.find(x => x.name == this.fieldName && x.isDefault == true);
      if (action == 'pageload') {
        itemF = this.itemFieldList.find(x => x.isDefault == true);
      }
      if (itemF != null && itemF.name != null) {
        this.isDefualt = true;
        if (action == 'pageload') {
          this.fieldName = itemF.name;
        }
      }


    }, err => {

      AppDevNotifyComponent.ErrorMessage("Something Went Wrong.");
    });
  }

  onSelectionValueChanged($event) {
    this.isDefualt = false;
    this.isBlankSelection = true;
    this.IsPrevExists = true;
    this.IsNxtExists = false;
    let itemF = this.itemFieldList.find(x => x.name == this.fieldName && x.isDefault == true);
    if (itemF != null && itemF.name != null) {
      this.isDefualt = true;
    }
  }

  LoadNextPreById(item) {
    this.SelectionFieldName = item.data.fieldName;
    this.onSelectionValueChanged(null);
  }

  DeleteNextPreById(item) {

    this.settingsService.RemoveNextPre(item.value).subscribe((result) => {
      if (result != null && result.flag != null && result.flag == 1) {
        AppDevNotifyComponent.SuccesMessage(result.msg);
      }
      else {
        AppDevNotifyComponent.ErrorMessage("Something Went Wrong.");
      }

    }, err => {

      AppDevNotifyComponent.ErrorMessage("Something Went Wrong.");
    });
  }


  @Input() needConfirmation: boolean = false;
  @Input() onNextPrevConfirm!: () => boolean;


  public onNextPrev(action: string) {

    if (this.needConfirmation) {
      const isConfirmed = this.onNextPrevConfirm();
      if (isConfirmed) {
        this.onNextPreviousButtonClicked(action);
      }
    } else {
      this.onNextPreviousButtonClicked(action);
    }
  }

}


